import { graphql } from 'gql.tada';

/**
 * A household change request as both sides of the feature need it: the parent's
 * banner and the admin's review panel show the same items, so they read the same
 * fragment rather than drifting apart.
 */
export const HouseholdChangeRequestFragment = graphql(`
  fragment HouseholdChangeRequestFragment on HouseholdChangeRequest {
    id
    state
    submittedAt
    submittedByName
    reviewedAt
    adminNote
    acceptedCount
    items {
      key
      label
      currentValue
      proposedValue
      changedSinceSubmitted
      decision
    }
  }
`);
